// extracted by mini-css-extract-plugin
export default {"date":"DatePicker_date__sFNAu","span":"DatePicker_span__vXafw","datePicker":"DatePicker_datePicker__fRG7B","calendarIcon":"DatePicker_calendarIcon__J1VUd"};